const config = {
  apiKey: 'AIzaSyBj7Jz5aIRFKO4VLnsEnyDfKvUNiAuDDEs',
  authDomain: 'pygar-holding.firebaseapp.com',
  databaseURL: 'https://pygar-holding.firebaseio.com/',
  projectId: 'pygar-holding',
  storageBucket: 'pygar-holding.appspot.com',
  messagingSenderId: '823700789316',
};

export default config;
